import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { WithStyles, withStyles } from "@material-ui/core";

import { styles } from "./NotificacionStyles";
import Campana from "../../UI/Campana/Campana";

interface OwnProps {
  asunto: string;
  fecha: string;
}
type PublicProps = OwnProps;
type Props = PublicProps & WithStyles<typeof styles>;

const Notificacion: React.FC<Props> = (props) => {
  const { classes, asunto } = props;

  return (
    <Grid container spacing={0}>
      <Grid item xs={2}>
        <Campana
          withRedDot={true}
          iconButtonProps={{
            "aria-controls": "notificaciones-menu",
            "aria-haspopup": "true",
          }}
        />
      </Grid>

      <Grid container item xs={10}>
        <Grid item xs container direction="column">
          <Grid item container alignItems="center" xs>
            <Typography className={classes.asunto} variant="body2" gutterBottom>
              {asunto}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default withStyles(styles)(
  Notificacion
) as React.ComponentType<PublicProps>;
